var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.0845C0 7.24792 7.16344 0.0844727 16 0.0844727C24.8366 0.0844727 32 7.24792 32 16.0845C32 24.921 24.8366 32.0845 16 32.0845C7.16344 32.0845 0 24.921 0 16.0845Z",
    fill: "#F2146F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2281 20.7095L22.9375 16.0845H18.5V13.0845C18.5 11.8188 19.1188 10.5845 21.1063 10.5845H23.125V6.64697C23.125 6.64697 21.2938 6.33447 19.5438 6.33447C15.8875 6.33447 13.5 8.5501 13.5 12.5595V16.0845H9.4375V20.7095H13.5V31.8907C14.3156 32.0188 15.15 32.0845 16 32.0845C16.85 32.0845 17.6844 32.0188 18.5 31.8907V20.7095H22.2281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/FACEBOOK.16a14508ceb3bbedb8d0571cb9254e1b.svg";
export { ForwardRef as ReactComponent };